import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const StyledIcon = styled(FontAwesomeIcon)`
  margin-bottom: 1%;
  opacity: 0.7;
  color: #494f59;
  flex-shrink: 0;
  justify-content: flex-end;
  transition: all 0.3s ease-in-out;
  &:hover {
    opacity: 1;
    cursor: pointer;
    color: red;
  }
`
